__turbopack_context__.v({
  "className": "bai_jamjuree_4a54d62d-module__05mIgq__className",
  "variable": "bai_jamjuree_4a54d62d-module__05mIgq__variable",
});
